import { Button } from '@/common/ui/button'
import { Plus, Info } from 'lucide-react'
import { Link } from 'react-router-dom'
import OtpProviderTable from '@/modules/otp-provider/components/OtpProviderTable'
import type { components } from '@/schema'

type OtpProvider = components['schemas']['AdminOtpProviderResponse']

interface OtpProviderListingProps {
	data: OtpProvider[]
	isLoading: boolean
}

export default function OtpProviderListing({
	data,
	isLoading,
}: OtpProviderListingProps) {
	return (
		<div className="space-y-6">
			{/* Header with actions */}
			<div className="flex items-center justify-between">
				<h2 className="text-2xl font-semibold">
					จัดการผู้ให้บริการ OTP ({data.length} รายการ)
				</h2>
				<Button asChild>
					<Link to="/operator/otp-provider/create">
						<Plus className="mr-2 h-4 w-4" />
						เพิ่มผู้ให้บริการใหม่
					</Link>
				</Button>
			</div>

			{/* Info banner */}
			<div className="flex items-start gap-3 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-sm dark:border-blue-800 dark:bg-blue-950/30">
				<Info className="mt-0.5 h-4 w-4 shrink-0 text-blue-600 dark:text-blue-400" />
				<div className="text-blue-800 dark:text-blue-200">
					<p className="font-medium">
						ผู้ให้บริการ OTP สำหรับส่ง SMS ยืนยันตัวตนของผู้เล่น
					</p>
					<p className="mt-0.5">
						สามารถมีผู้ให้บริการได้หลายราย
						แต่จะมีเพียงหนึ่งรายที่เปิดใช้งานในแต่ละเวลา
						การสร้างผู้ให้บริการใหม่จะทำให้เปิดใช้งานโดยอัตโนมัติและปิดการใช้งานรายการอื่น
					</p>
				</div>
			</div>

			{/* Table */}
			<OtpProviderTable data={data} isLoading={isLoading} />
		</div>
	)
}
